import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// ReactQueryDevtools removed - it adds a floating icon that can be confusing to users
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import { AuthProvider } from '../contexts/AuthContext';
import { FCMProvider } from '../contexts/FCMContext';
import { SocketProvider } from '../contexts/SocketContext';
import { BrandingProvider } from '../contexts/BrandingContext';
// OLD OnboardingProvider REMOVED - was redirecting to /onboarding/summary
// even for users on conversational flow (/onboarding/chat)
// import { OnboardingProvider } from '../contexts/OnboardingContext';

interface GlobalProviderProps {
  children: React.ReactNode;
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: error => {
        console.error('Mutation failed:', error);
      },
    },
  },
});

const GlobalProvider: React.FC<GlobalProviderProps> = ({ children }) => {
  return (
    <Theme appearance='light' className='w-full'>
      {/* V1.5.M10 B-P1: branding resolves pre-auth (invite/host) and applies
          the client palette/title/favicon before anything else renders.
          Mounted outside Router/Auth on purpose: it has no dependency on
          either, and auth screens must already be branded. */}
      <BrandingProvider>
        <Router>
          <QueryClientProvider client={queryClient}>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
              <AuthProvider>
                <SocketProvider>
                  <FCMProvider>{children}</FCMProvider>
                </SocketProvider>
              </AuthProvider>
            </GoogleOAuthProvider>
            {/* ReactQueryDevtools removed - floating icon was confusing users */}
          </QueryClientProvider>
        </Router>
      </BrandingProvider>
    </Theme>
  );
};

export default GlobalProvider;
